

// client/src/components/dashboard/DashboardFilters.jsx

import React from "react";

const VENDORS = [
  "AIRTEL", "ANONET", "MICROSCAN", "NTT", "NTT_GLOBAL",
  "SIFY", "SYMPHONY", "TATA_TELE", "TATA COMMUNICATIONS",
  "TIKONA", "XTELIFY",
];

const VENDOR_LABELS = {
  NTT_GLOBAL:           "NTT GLOBAL",
  TATA_TELE:            "TATA TELE",
  "TATA COMMUNICATIONS":"TATA COMMUNICATIONS",
};

const STATUS_OPTIONS = [
  { value: "PAID",           label: "Paid",           dot: "#10b981" },
  { value: "UNPAID",         label: "Unpaid",         dot: "#ef4444" },
  // { value: "PARTIALLY_PAID", label: "Partially Paid", dot: "#f59e0b" },
];

export default function DashboardFilters({ filters, setFilters, quarters = [] }) {

  const update = (field, value) =>
    setFilters((prev) => ({ ...prev, [field]: value }));

  return (
    <div style={styles.wrap}>

      {/* Invoice Number */}
      <div style={styles.fieldGroup}>
        <label style={styles.label}>Invoice Number</label>
        <div style={styles.inputWrap}>
          <span style={styles.inputIcon}>🔎</span>
          <input
            type="text"
            placeholder="e.g. INV-2024-001"
            value={filters.invoiceNumber}
            onChange={(e) => update("invoiceNumber", e.target.value)}
            style={styles.input}
          />
        </div>
      </div>

      {/* Vendor */}
      <div style={styles.fieldGroup}>
        <label style={styles.label}>Vendor</label>
        <div style={styles.selectWrap}>
          <select
            value={filters.vendor}
            onChange={(e) => update("vendor", e.target.value)}
            style={styles.select}
          >
            <option value="">All Vendors</option>
            {VENDORS.map((v) => (
              <option key={v} value={v}>{VENDOR_LABELS[v] || v}</option>
            ))}
          </select>
          <span style={styles.selectChevron}>▾</span>
        </div>
      </div>

      {/* Billing Quarter */}
      <div style={styles.fieldGroup}>
        <label style={styles.label}>Billing Quarter</label>
        <div style={styles.selectWrap}>
          <select
            value={filters.billingQuarter}
            onChange={(e) => update("billingQuarter", e.target.value)}
            style={styles.select}
          >
            <option value="">All Quarters</option>
            {quarters.map((q) => (
              <option key={q} value={q}>{q}</option>
            ))}
          </select>
          <span style={styles.selectChevron}>▾</span>
        </div>
      </div>

      {/* Payment Status */}
      <div style={styles.fieldGroup}>
        <label style={styles.label}>Payment Status</label>
        <div style={styles.selectWrap}>
          <select
            value={filters.paymentStatus}
            onChange={(e) => update("paymentStatus", e.target.value)}
            style={styles.select}
          >
            <option value="">All Status</option>
            {STATUS_OPTIONS.map((s) => (
              <option key={s.value} value={s.value}>{s.label}</option>
            ))}
          </select>
          <span style={styles.selectChevron}>▾</span>
        </div>
      </div>

    </div>
  );
}

const styles = {
  wrap: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "16px",
    padding: "20px 24px",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },

  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },

  label: {
    fontSize: "11px",
    fontWeight: "700",
    color: "#374151",
    letterSpacing: "0.06em",
    textTransform: "uppercase",
  },

  // Input with icon
  inputWrap: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  inputIcon: {
    position: "absolute",
    left: "10px",
    fontSize: "13px",
    pointerEvents: "none",
    lineHeight: 1,
  },
  input: {
    width: "100%",
    height: "36px",
    paddingLeft: "32px",
    paddingRight: "12px",
    fontSize: "13px",
    fontWeight: "400",
    color: "#111827",
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "7px",
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    transition: "border-color 0.15s",
  },

  // Select with custom chevron
  selectWrap: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  select: {
    width: "100%",
    height: "36px",
    paddingLeft: "12px",
    paddingRight: "32px",
    fontSize: "13px",
    fontWeight: "400",
    color: "#111827",
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "7px",
    outline: "none",
    appearance: "none",
    WebkitAppearance: "none",
    cursor: "pointer",
    boxSizing: "border-box",
    fontFamily: "inherit",
    transition: "border-color 0.15s",
  },
  selectChevron: {
    position: "absolute",
    right: "10px",
    fontSize: "11px",
    color: "#9ca3af",
    pointerEvents: "none",
  },
};